// Copyright (C) 2021-2022 Intel Corporation
// Copyright (C) 2022-2023 CVAT.ai Corporation
//
// SPDX-License-Identifier: MIT

import { connect } from 'react-redux';

import CreateReferenceComponent from 'components/create-reference-page/create-reference-page';
import { CreateReferenceData } from 'components/create-reference-page/create-reference-content';
import { createReferenceAsync } from 'actions/references-actions';

interface DispatchToProps {
    onCreate: (data: CreateReferenceData, onProgress?: (status: string) => void) => Promise<any>;
}

function mapDispatchToProps(dispatch: any): DispatchToProps {
    return {
        onCreate: (data, onProgress) => dispatch(createReferenceAsync(data, onProgress)),
    };
}

export default connect(null, mapDispatchToProps)(CreateReferenceComponent);
